import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as API from 'app/public_api';
import { ProfilePageState } from "utils/types";


const rResearcher = createAsyncThunk(
    'profilePg/rResearcher', 
    async (data:{
        randomID: string,
    }, thunkAPI)=>{
        const rsr = await API.rRsr(data.randomID)
        if(!rsr){
            return thunkAPI.rejectWithValue("Researcher not found or not set to be public.")
        }
        return  rsr;
    }
)

export const profilePgThunks = { rResearcher };




export const initialState: ProfilePageState = {
    researcher: null,
    status: "idle",
    errorMsg: null,
}

// profilePgS
export default createSlice({
    name: 'profilePage',
    initialState,
    reducers: {},
    extraReducers: builder=>{

        // Fclt Dept thunk
        builder.addCase(rResearcher.pending, (state, action) => {
            state.status = 'loading';
        });
        builder.addCase(rResearcher.fulfilled, (state, action) => {
            state.status = 'succeeded';

            state.researcher = action.payload;
        });
        builder.addCase(rResearcher.rejected, (state, action) => {
            state.status = 'failed';
            if(action.payload){
                state.errorMsg = action.payload as string;
            }else{
                state.errorMsg = action.error.message;
            }

            state.researcher = initialState.researcher;
        });

    }
});